import { PaginationStateProps } from 'common/state/types';
import { ProviderOutstanding, ProviderSummary } from './actions';

// #region ProviderOutstanding
export interface ProviderOutstandingsState extends PaginationStateProps {
  pending: boolean;
  providerOutstandings: ProviderOutstanding[] | null;
  error?: string;
}

export const defaultProviderOutstandingsState: ProviderOutstandingsState = {
  pending: false,
  providerOutstandings: null,
  error: null,
};
// #endregion

// #region ProviderSummarie
export interface ProviderSummariesState extends PaginationStateProps {
  pending: boolean;
  summaries: ProviderSummary[] | null;
  error?: string;
}

export const defaultProviderSummariesState: ProviderSummariesState = {
  pending: false,
  summaries: null,
  error: null,
};
// #endregion
